import React, {useState} from 'react';
import {Trans} from 'react-i18next';
import _get from 'lodash/get';
import DataTable from '../../../../../components/datatable/DataTable';
import ActionButton from '../../../../../components/datatable/ActionButton';
import ElevatedButton from '../../../../../components/formik/ElevatedButton';
import EditStoresModal from './EditStoresModal';
import {handleTemplateExport} from '../../../../../utils/skincareUtils';
import OverLayLoader from '../../../../../components/spinner/OverLayLoader';

export default function DifferentConsent({
  data = [],
  isLoading = true,
  formikProps,
  categories,
  isTechnicalSupport,
}) {
  const [editInfo, setEditInfo] = useState({template_id: null, store_ids: []});
  const [showEditStoresModal, setShowEditStoresModal] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const getStoreIdsByTemplateId = (data, templateId) => {
    const item = data.find(d => d.template_id === templateId);
    return _get(item, 'store_ids', []);
  };

  const handleExport = async (templateId, templateName) => {
    const sanitizedName = templateName
      .replace(/[^a-z0-9]/gi, '_')
      .toLowerCase();
    await handleTemplateExport({
      templateId,
      fileName: `UserConsent_${sanitizedName}`,
      setIsExporting,
    });
  };

  const columns = [
    {
      Header: (
        <Trans i18nKey="p.s.c.customization.template.name">Template Name</Trans>
      ),
      accessor: 'label',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
    },
    {
      Header: (
        <Trans i18nKey="p.s.uiconfiguration.userconsnt.assigned.locations">
          Assigned Locations
        </Trans>
      ),
      accessor: 'store_ids',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
      Cell: ({
        cell: {
          row: {original},
        },
      }) => {
        const storeCategory = _get(categories, 'storeCategory', []);
        const storeSets = new Set(data.flatMap(item => item.store_ids));
        const filteredStoreCategory =
          _get(original, 'value') === -1
            ? storeCategory.filter(item => !storeSets.has(item.value))
            : storeCategory.filter(item =>
                getStoreIdsByTemplateId(data, _get(original, 'value')).includes(
                  item.value
                )
              );

        return (
          <div className="text-left">
            {filteredStoreCategory.map(item => (
              <li key={item.value}>{item.label}</li>
            ))}
          </div>
        );
      },
    },
    {
      Header: <Trans i18nKey="p.c.listrequests.actions">Actions</Trans>,
      accessor: 'value',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
      Cell: ({
        cell: {
          row: {index, original},
        },
      }) => (
        <div className="text-center">
          {_get(original, 'value', -1) === -1 ? (
            '-'
          ) : (
            <ActionButton
              type={'edit'}
              onClick={() => {
                setEditInfo({
                  idx: index,
                  template_id: _get(original, 'value'),
                  store_ids: getStoreIdsByTemplateId(
                    data,
                    _get(original, 'value')
                  ),
                });
                setShowEditStoresModal(true);
              }}
            />
          )}
        </div>
      ),
    },
    ...(isTechnicalSupport
      ? [
          {
            Header: <Trans i18nKey="p.s.c.customization.file">File</Trans>,
            accessor: 'file',
            disableSortBy: true,
            style: {width: '5%', textAlign: 'center'},
            Cell: ({
              cell: {
                row: {original},
              },
            }) => (
              <div className="text-center">
                {original.value === -1 ? (
                  <span>-</span>
                ) : (
                  <ElevatedButton
                    type="custom"
                    faIcon="fa-download"
                    text={
                      <Trans i18nKey="p.s.c.customization.export.html.file">
                        Export HTML File
                      </Trans>
                    }
                    onClick={() => handleExport(original.value, original.label)}
                    disabled={isExporting}
                  />
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={_get(categories, 'tempCategory', [])}
        initState={{
          pageSize: 5,
        }}
        loading={isLoading}
      />
      <EditStoresModal
        show={showEditStoresModal}
        handleCloseModel={() => {
          setEditInfo({});
          setShowEditStoresModal(false);
        }}
        storeCategory={_get(categories, 'storeCategory', [])}
        editStoreIds={_get(editInfo, 'store_ids', [])}
        disabledStoreIds={data.flatMap(item => item.store_ids)}
        handleChooseModel={ids => {
          formikProps.setFieldValue(
            `user_consents[${_get(editInfo, 'idx')}].store_ids`,
            ids
          );
          setEditInfo({});
          setShowEditStoresModal(false);
        }}
      />
      {isExporting && (
        <OverLayLoader
          text={
            <Trans i18nKey="c.spinner.overlay.loader.exporting">
              Exporting...
            </Trans>
          }
        />
      )}
    </div>
  );
}
